<template>
  <div class="app-wrapper">
    <router-view :key="$route.fullPath"/>
    <!-- <div class="loading" v-else v-loading.fullscreen.lock="!ready"></div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Sidebar from "@/components/layouts/Sidebar";

export default {
  components: {
    Sidebar
  },
  computed: {
    ...mapState({
      ready: state=>state.status.ready
    })
  }
}
</script>

<style lang="scss">
#app{
  height: 100%;
  display: flex;
  flex-direction: column;
  #top{
    height: 50px;
    border-bottom: solid 1px #e6e6e6;
    background: #1c202a;
  }
  #main{
    display: flex;
    flex-grow: 1;
    #content{
      margin-right: 10px;
      margin-left: 10px;
      margin-top: 10px;
      flex-grow: 1;
    }
  }
}

.app-wrapper{
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  &>div{
    flex-grow: 1;
    height: 100%;
    width: 100%;
  }
}
</style>
